export function escapeHtml(value: unknown): string {
  return String(value ?? "").replace(
    /[&<>"']/g,
    (c) =>
      ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[
        c
      ]!,
  );
}
export const e = escapeHtml;
export function button(
  action: string,
  label: string,
  options: {
    primary?: boolean;
    small?: boolean;
    disabled?: boolean;
    title?: string;
    extra?: string;
  } = {},
): string {
  return `<button type="button" data-action="${e(action)}" class="button ${options.primary ? "primary" : ""} ${options.small ? "small" : ""}" ${options.disabled ? "disabled" : ""} ${options.title ? `title="${e(options.title)}"` : ""} ${options.extra ?? ""}>${label}</button>`;
}
export function formatTime(seconds: number): string {
  const s = Math.max(0, Math.ceil(seconds));
  return `${Math.floor(s / 60)
    .toString()
    .padStart(2, "0")}:${(s % 60).toString().padStart(2, "0")}`;
}
export function toast(message: string): void {
  const host = document.querySelector("#toast-root")!;
  const item = document.createElement("div");
  item.className = "toast";
  item.textContent = message;
  host.append(item);
  setTimeout(() => item.remove(), 4800);
}
